<template>
    <div
        class="top-panel"
    >
        <div
            ref="label"
            class="location-label"
            @mouseover="onMouseOver(localName)"
            @mouseout="onMouseOut"
        >
            {{ localName }}
        </div>
        <MobileNavBar
            v-if="$screens.mobile"
            :model="mobileNavModel"
        />
        <Controls
            v-else
            :model="controlsModel"
        />
        <div
            v-if="tooltipContent"
            ref="tooltip"
            class="tooltip-content"
        >
            {{ tooltipContent }}
        </div>
    </div>
</template>

<script>
import RegionModel from '@/model/RegionModel';
import MobileNavModel from '@/model/MobileNavModel';
import ControlsModel from '@/model/ControlsModel';
import Controls from './Controls.vue';
import MobileNavBar from './MobileNavBar.vue';

export default {
    components: {
        Controls,
        MobileNavBar
    },
    props: {
        mobileNavModel: {
            type: MobileNavModel,
            required: true
        },
        controlsModel: {
            type: ControlsModel,
            required: true
        },
        regionModel: {
            type: RegionModel,
            required: true
        },
    },
    data() {
        return {
            tooltipContent: ''
        };
    },
    computed: {
        localName() {
            return this.regionModel.region && this.regionModel.region.localName;
        }
    },
    async updated() {
        await this.$nextTick();
        if (this.tooltipContent && this.isInternetExplorer()) {
            const labelX = this.$refs.label.getBoundingClientRect().left;
            const tooltipX = this.$refs.tooltip.getBoundingClientRect().left;
            this.$refs.tooltip.style.transform = `translateX(${labelX - tooltipX}px)`;
        }
    },
    methods: {
        onMouseOver(location) {
            this.tooltipContent = location;
        },
        onMouseOut() {
            this.tooltipContent = '';
        },
        isInternetExplorer() {
            return !!window.document.documentMode;
        }
    }
};
</script>

<style lang="postcss" scoped>
.top-panel {
    @apply
        w-full
        sticky
        top-header-sm
        z-10
        flex
        flex-row
        flex-shrink-0
        justify-between
        items-center
        px-8
        border-b
        border-neutral-5
        bg-white;
    height: 75px;
}

.location-label {
    @apply text-primary-4 font-normal;
    font-size: 16px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    cursor: default;
}

.tooltip-content {
    @apply block absolute bg-white text-primary-4 font-normal text-lg shadow-tooltip p-2;
    pointer-events: none;
    top: 60px;
    left: 32pt;
    z-index: 11;
}

@screen md {
    .top-panel {@apply top-header; }
    .location-label { @apply text-xl; }
    .tooltip-content { @apply text-xl; }
}

@screen mobile {
    .location-label { @apply ml-0 pr-2; }
    .top-panel {
        @apply px-4;
        height: 40px;
    }
    .tooltip-content {
        @apply text-base;
        left: 0;
        top: 40px;
    }
}
</style>
<style lang="postcss">
.top-panel .svg-inline {
    @apply mx-auto;
    @apply w-6 h-6;
    /* width: unset; */
}
</style>
